import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from "@air/primitive-icon-button";
import { tailwindMerge } from "@air/tailwind-variants";
import { forwardRef, memo } from "react";
const _AnnotationIconButton = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(IconButton, {
        appearance: "ghost",
        className: tailwindMerge("text-pigeon-100 hover:bg-pigeon-100/15 hover:text-white", className),
        color: "grey",
        ref: forwardedRef,
        size: "small",
        ...restOfProps
    });
});
_AnnotationIconButton.displayName = "_AnnotationIconButton";
export const AnnotationIconButton = /*#__PURE__*/ memo(_AnnotationIconButton);
AnnotationIconButton.displayName = "AnnotationIconButton";
